import { SearchItemType } from "@/components/Store/StoreSearchInput/storeSearchInput.types";

export const ZOOM_INITIAL = 14.0;

export const STORE_DIRECTIONS_MESSAGE_ID = "store-directions-error";

export const STORE_SEARCH_INPUT_TYPES = new Map<SearchItemType, number>([
    [SearchItemType.Locality, 5]
]);
